import { Component, OnInit, Optional, Inject } from '@angular/core';
import { SharedService } from '../../_service/shared.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroupDirective, FormBuilder, FormGroup, NgForm, Validators, FormArray } from '@angular/forms';
import { MiscService } from '../../_service/misc.service';
import { LeadsService } from 'src/app/_service/leads.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DentalService } from 'src/app/_service/dental.service';
declare var $: any;

@Component({
  selector: 'app-spok-remarks',
  templateUrl: './spok-remarks.component.html',
  styleUrls: ['./spok-remarks.component.css']
})
export class SpokRemarksComponent implements OnInit {

  spokForm: FormGroup; submitted = false; loading: boolean = false; scanId: any = ''; myrole: string;
  allStatus = []; allStatus_copy = []; allSubStatus = []; allSubStatus_copy = [];
  constructor(public dialogRef: MatDialogRef<SpokRemarksComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any, private router: Router, private sharedapi: SharedService, private formBuilder: FormBuilder, private activatedRoute: ActivatedRoute,private dentalapi: DentalService) {
    dialogRef.disableClose = true;
    this.scanId = data.scanId;
    this.spokForm = this.formBuilder.group({
      'status': [null, Validators.required],
      'sub_status': [null, Validators.required],
      'spoc_followup_datetime': [null],
      'remark': [null],
    });

  }

  get f() { return this.spokForm.controls; }

  ngOnInit(): void {
    this.sharedapi.getRole().subscribe((item: string) => { this.myrole = item; });
    this.myrole = localStorage.getItem('role');
    this.getDentalSpokRemarkStatus();
    this.patchSpokData();
  }

  searchOnSelect(searchtText: string, type) {
    if (type == 'status') {
      this.allStatus = this.sharedapi.searchData(searchtText, this.allStatus_copy, "name");
    }
  }

  setSearchValue(type) {
    if (type == 'status') {
      $("#allStatusSearch").val('');
      $("#allStatusSearch").focus();
      this.allStatus = this.allStatus_copy;
    }
  }

  getSpocSubStatus(event)
  {
    this.getDentalSpokRemarkSubStatus(event);
  }

  addRemoveValidatorOfSpoc(event){
    if(event != 9 && event != 18 && event != 19 && event != 20 && event != 21 && event != 22 && event != 23)
    {
      this.spokForm.controls['spoc_followup_datetime'].setValidators(Validators.required);
    } 
    else 
    {
      this.spokForm.controls['spoc_followup_datetime'].setValidators(null);
    }
    this.spokForm.controls['spoc_followup_datetime'].updateValueAndValidity();
  }

  async createSpok() {
    this.submitted = true;
    this.loading = true;

    if (this.spokForm.invalid) {
      this.loading = false;
      return;
    }
    this.spokForm.value.scanId = parseInt(this.scanId);
    await this.dentalapi.addDentalSpokRemarkData(this.spokForm.value)
      .subscribe((data: any) => {
        this.submitted = false;
        this.loading = false;
        if (data.status) {
          this.sharedapi.presentToast(data.msg);
        }
        else {
          this.sharedapi.presentToast(data.msg);
        }
      }, error => {
        this.sharedapi.checkError(error);
      });
  }


  CloseModal(): void {
    this.dialogRef.close();
  }

  async getDentalSpokRemarkStatus() {
    await this.dentalapi.getDentalSpokRemarkStatus(0).subscribe((data: any) => {
      if (data.status) {
        this.allStatus = data.data;
        this.allStatus_copy = this.allStatus;
      } else {
        this.allStatus = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  async getDentalSpokRemarkSubStatus(parent_id) {
    await this.dentalapi.getDentalSpokRemarkStatus(parent_id).subscribe((data: any) => {
      if (data.status) {
        this.allSubStatus = data.data;
        this.allSubStatus_copy = this.allSubStatus;
      } else {
        this.allSubStatus = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  async patchSpokData() {
    this.dentalapi.getSingleSpokRemarkData(this.scanId).subscribe((response: any) => {
      if (response.status) {
        this.spokForm.patchValue({
          'status': response.data.spok_status_id,
          'sub_status': response.data.spoc_sub_status_id,
          'spoc_followup_datetime': response.data.spoc_followup_date,
          'remark': response.data.spok_remarks,
        })
        if(response.data.spok_status_id)
        {
          this.getSpocSubStatus(response.data.spok_status_id);
        }
        this.addRemoveValidatorOfSpoc(response.data.spok_status_id);
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

}
